const groupActivityDetail = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/groupActivityDetail.vue'
  )
const groupActivityTeamDetail = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/groupActivityTeamDetail.vue'
  )
const groupActivityRanking = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/groupActivityRanking.vue'
  )

const participationTaskList = () =>
  import(
    /* webpackChunkName: "group~activity" */ 'page/platform/appCommunity/participationTaskList.vue'
  )

let routes = [
  {
    name: 'groupActivityDetail',
    path: '/group/activity',
    component: groupActivityDetail,
    meta: {
      pageName: '群活动详情页',
      business: '平台',
      title: '群活动详情页'
    }
  },
  {
    name: 'groupActivityTeamDetail',
    path: '/group/activity/team/:id',
    component: groupActivityTeamDetail,
    meta: {
      pageName: '群活动队伍详情页',
      business: '平台',
      title: '群活动队伍详情页'
    }
  },
  {
    name: 'groupActivityRanking',
    path: '/group/activity/ranking',
    component: groupActivityRanking,
    meta: {
      pageName: '群活动排行页',
      business: '平台',
      title: '群活动排行页'
    }
  },
  {
    name: 'participationTaskList',
    path: '/group/activity/taskList',
    component: participationTaskList,
    meta: {
      pageName: '我参与的群组队活动',
      business: '平台',
      title: '我参与的群组队活动'
    }
  }
]

export default routes
